/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![StickerIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABUElEQVR4nN1VvUoDQRC+ykYFQVvrvIWp0u38IGxmDhTRZ1DEBImlPoRW2gQheRJ9C6soaGmhMncHkdzt/UUQXZjibma+b353o+hfHSLZRpZ7YH1D1s8mkvrIBNF3guBA+twUGHMiL4aVI7DIlwfXVEjHOYI2ZcFwFq8FGfwUuCZSSgCsZ73e3iqQDGo0t9C2lMB7v5b8Q1yvIgjZlmdAMjBHZBlWZhCw/d0e4Hwahs7FW8DymK+9PCQ6kvPWBI7k2HQpid7YEtkyAsk18/5mtj8nrQmA5N1RzFHgAMuu2RT4zZr04ANIbxH7O0QHGyaO4y6w3pkOSaf2baMaCqR1k4HktBR0KQLSqfl571eQ5QpInr7pj5YmcBx3M7/LhawuAg1rdtn5bIMXIh+VlEgmbRYJ64Anhug7NuctCUb1n0zSsd3nFdMzmwfWP6wF/mfPF5vminLaAaoTAAAAAElFTkSuQmCC)
 */
export const StickerIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M6 2h12a4 4 0 0 1 4 4v7.5a.5.5 0 0 1-.5.5H19a5 5 0 0 0-5 5v2.5a.5.5 0 0 1-.5.5H6a4 4 0 0 1-4-4V6a4 4 0 0 1 4-4Zm.5 8a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM19 8.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm-9.91 2.94a1 1 0 0 0-1.66 1.12 5.5 5.5 0 0 0 9.14 0 1 1 0 0 0-1.66-1.12 3.5 3.5 0 0 1-5.82 0Z"
        clipRule="evenodd"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M21.66 16c.03 0 .05.03.04.06a3 3 0 0 1-.58.82l-4.24 4.24a3 3 0 0 1-.82.58.04.04 0 0 1-.06-.04V19a3 3 0 0 1 3-3h2.66Z"
        className={colorClass}
      />
    </svg>
  );
};
